import React from 'react'
import { Map as LeafletMap, TileLayer, Marker, Popup } from 'react-leaflet'
import L from 'leaflet';

var matildeIcon = new L.Icon({
    iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-violet.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  });

  var secondIcon = new L.Icon({
    iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  });

const NarrativeMap = ({ tags }) => {
    const MyPopupMarker = ({ icon, content, position }) => (
        <Marker icon={icon} position={position}>
            <Popup>{content}</Popup>
        </Marker>
    )

    return (
        <LeafletMap style={{ height: 250, borderRadius: 4, marginBottom: 20 }} center={[tags.lang, tags.lat]} zoom={tags.zoom} maxZoom={20} dragging={true}>
            <TileLayer
                attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
            />
            {!tags?.lat2 && !tags?.lat3 && <MyPopupMarker icon={matildeIcon} content='Matilde' position={[tags.lang, tags.lat]} />}
            {tags?.lat2 &&
                <>
                    <MyPopupMarker icon={matildeIcon} content='Matilde' position={[tags.lang, tags.lat]} />
                    <MyPopupMarker icon={secondIcon} content={tags.marker2} position={[tags.lang2, tags.lat2]} />
                </>
            }
            {tags?.lat3 &&
                <>
                    <MyPopupMarker icon={matildeIcon} content='Matilde' position={[tags.lang, tags.lat]} />
                    <MyPopupMarker icon={secondIcon} content={tags.marker2} position={[tags.lang2, tags.lat2]} />
                    <MyPopupMarker icon={secondIcon} content={tags.marker3} position={[tags.lang3, tags.lat3]} />
                </>
            }
            {tags?.lat4 &&
                <>
                    <MyPopupMarker icon={matildeIcon} content='Matilde' position={[tags.lang, tags.lat]} />
                    <MyPopupMarker icon={secondIcon} content={tags.marker2} position={[tags.lang2, tags.lat2]} />
                    <MyPopupMarker icon={secondIcon} content={tags.marker3} position={[tags.lang3, tags.lat3]} />
                    <MyPopupMarker icon={secondIcon} content={tags.marker4} position={[tags.lang4, tags.lat4]} />
                </>
            }
        </LeafletMap>
    )
}

export default NarrativeMap